import { render } from "./ProfileMenu.vue?vue&type=template&id=f601c9aa&scoped=true&ts=true"
import script from "./ProfileMenu.vue?vue&type=script&lang=ts"
export * from "./ProfileMenu.vue?vue&type=script&lang=ts"

import "./ProfileMenu.vue?vue&type=style&index=0&id=f601c9aa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f601c9aa"]])

export default __exports__